import { h, render, Component } from 'preact';
import moment from 'moment';
import Marker from './marker/marker';
import './markers-list.scss';

export default class MarkersList extends Component {
    constructor(props) {
        super(props);

        let today = moment().format('YYYY-MM-DD');
        this.state = {
            markers: [],
            activeKey: 0,
            trackPeriod: '1',
            customDateTime: new Date(),
            startDate: today,
            startTime: '00:00',
            stopDate: today,
            stopTime: '23:59'
        };
    }

    componentDidMount() {
        this.props.markersService.setMarkersOnMap(this.props.markers, 20);
        this.setState({ markers: [...this.props.markers] });
        this.updateTimeout = setTimeout(() => { this.updateMarkersRequest() } , this.props.updateTimeoutValue);
    }    

    updateMarkersRequest() {
        this.props.radar.updateMarkersRequest()
        .then((data) => {
            this.props.markersService.updateMarkers(data);
            this.setState({ markers: this.getUpdatesMarkers(data) });
            this.props.radar.setCurrentMarker(this.state.markers[this.state.activeKey]);
            this.props.radar.followObject();
            this.updateTimeout = setTimeout(() => { this.updateMarkersRequest() } , this.props.updateTimeoutValue);
        });            
    }

    getUpdatesMarkers(updateData) {
        return this.state.markers.reduce((arr, e) => {
            let newMarker = {...e};
            let updateDataElement = updateData.filter(item => item.id == e.id);
            if (!!updateDataElement[0]) {
                for(let prop in updateDataElement[0]) {
                    newMarker[prop] = updateDataElement[0][prop];
                }
            }
            arr.push(newMarker);
            return arr;
        },[]);
    }

    _onClickMarker(key, marker) {
        this.setState({activeKey:key});
        this.props.radar.setCurrentMarker(marker);
        let isToFollow = this.props.radar.isFollowObject();
        this.props.radar.setToFollow(true);
        this.props.radar.followObject();
        this.props.radar.setToFollow(isToFollow);
    }

    _onTrackPeriodChange = (event) => {
        this.setState({ trackPeriod: event.target.value });
    }

    _addTrack = (objectId) => {
        let self = this;
        let startTime;
        let stopTime;
        switch (this.state.trackPeriod) {
            case '1':
                startTime = moment().subtract(3, 'hour');
                stopTime = moment();
                break;
            case '2':
                startTime = moment().subtract(24, 'hour');
                stopTime = moment();
                break;
            case '4':
                startTime = moment().subtract(1, 'day').startOf('day');
                stopTime = moment().subtract(1, 'day').endOf('day');
                break;
            case '5':
                startTime = moment().startOf('isoWeek');
                stopTime = moment().endOf('isoWeek');
                break;
            case '6':
                startTime = moment().subtract(1, 'week').startOf('week');
                stopTime = moment().subtract(1, 'week').endOf('week');
                break;
            case '7':
                if (this.state.startDate && this.state.startTime
                    && this.state.stopDate && this.state.stopTime
                ) {
                    startTime = `${this.state.startDate} ${this.state.startTime}:00`;
                    stopTime = `${this.state.stopDate} ${this.state.stopTime}:59`;
                }
                else {
                    alert(fmtools.translate('RadarErrorGetTrack'));
                    return new Promise(resolve => resolve(false));
                }
                break;
            default:
                startTime = moment().startOf('day');
                stopTime = moment().endOf('day');
                break;
        }
        if (this.state.trackPeriod != '7') {
            startTime = startTime.utc().format('YYYY-MM-DD HH:mm:ss');
            stopTime = stopTime.utc().format('YYYY-MM-DD HH:mm:ss');
        }
        return new Promise(resolve => {
            this.props.radar.getTrackRequest({
                objectId,
                startTime: startTime,
                stopTime: stopTime
            }).then(routeInfo => {
                if (!routeInfo) {
                    resolve(false);
                }
                self.props.routesService.setRouteOnMap(routeInfo, {
                    trackStyle: 'object',
                    showFuelings: false,
                    showStops: true
                });
                resolve(true);
            });
        });
    }

    _removeTrack = (objectId) => {
        this.props.routesService.clearRoute(objectId);
    }

    _onStartDateChanged = (event) => {
        this.setState({ startDate: event.target.value });
    }

    _onStartTimeChanged = (event) => {
        this.setState({ startTime: event.target.value });
    }

    _onStopDateChanged = (event) => {
        this.setState({ stopDate: event.target.value });
    }

    _onStopTimeChanged = (event) => {
        this.setState({ stopTime: event.target.value });
    }

    render(props, state) {
        return (
            <div class="markers-list-wrapper">
                <div class="markers-list">
                    {
                        state.markers.map( (marker, key) => {
                            return (
                                <Marker marker={marker}
                                    allowTrack={props.allowTrack}
                                    addTrack={this._addTrack}
                                    removeTrack={this._removeTrack}
                                    active={state.activeKey == key}
                                    key={key} 
                                    onClick={e=>{this._onClickMarker(key, marker)}}/>
                            )
                        })
                        }
                </div>
                {
                    props.allowTrack &&
                    <div>
                        <hr />
                        <div class="track-period">
                            <span class="track-period-label">{fmtools.translate('TrackPeriod')}</span>
                            <select onChange={this._onTrackPeriodChange}>
                                <option value="1">{fmtools.translate('last3hour')}</option>
                                <option value="2">{fmtools.translate('last24hour')}</option>
                                <option value="3">{fmtools.translate('this_day')}</option>
                                <option value="4">{fmtools.translate('last_day')}</option>
                                <option value="5">{fmtools.translate('this_week')}</option>
                                <option value="6">{fmtools.translate('last_week')}</option>
                                <option value="7">{fmtools.translate('AtChoice')}</option>
                            </select>
                        </div>
                        {
                            this.state.trackPeriod == '7' &&
                            <div>
                                <span class="track-period-input-label">{fmtools.translate('BeginBig')}</span>
                                <input
                                    class="track-period-date"
                                    type="date"
                                    value={state.startDate}
                                    onChange={this._onStartDateChanged}
                                />
                                <input
                                    class="track-period-start-time"
                                    type="time"
                                    value={state.startTime}
                                    onChange={this._onStartTimeChanged}
                                />
                                <br />
                                <span class="track-period-input-label">{fmtools.translate('EndBig')}</span>
                                <input
                                    class="track-period-date"
                                    type="date"
                                    value={state.stopDate}
                                    onChange={this._onStopDateChanged}
                                />
                                <input
                                    class="track-period-time"
                                    type="time"
                                    value={state.stopTime}
                                    onChange={this._onStopTimeChanged}
                                />
                            </div>
                        }
                    </div>
                }
            </div>
        );
    }
}